export function selected(state) {
  const { mam } = state;
  const index = mam.experiences.map(el => el._id).indexOf(mam.selectedId);
  if (index >= 0) {
    return mam.experiences[index];
  }
  return null;
}

export function messages(state) {
  const sel = selected(state);
  if (sel) {
    return sel.messages;
  }
  return null;
}

export function hasExperiences(state) {
  const { mam } = state;
  return mam.experiences && mam.experiences.length;
}
